import React from "react";
import styles from "./styles.module.css";
import { FormattedMessage } from "react-intl";
const UnsavedModal = ({
  open,
  title = "Title",
  subTitle = "",
  description = "",
  okText,
  canelText,
  noActions,
  handleClose,
  handleDiscard,
}) => {
  return (
    <div
      className={`${styles["modal-overlay"]} ${
        open ? styles["open"] : styles["hide"]
      }`}
    >
      {open && (
        <div className={`${styles["modal-wrapper"]}`}>
          {!!title && (
            <div className={`${styles["modal-title"]}`}>
              {title}
              <img
                src="/ui/images/Truman-UI-Modal-Close.svg"
                onClick={handleClose}
              />
            </div>
          )}

          <div
            className={`${styles["modal-content"]} `}
            onClick={(e) => e.stopPropagation()}
          >
            {subTitle && (
              <h4 className={`${styles["modal-subtitle"]}`}>{subTitle}</h4>
            )}
            {description && (
              <p className={`${styles["modal-description"]}`}>{description}</p>
            )}
          </div>
          {!noActions ? (
            <div className={`${styles["modal-footer"]}`}>
              <button onClick={handleClose}>
                {canelText || (
                  <FormattedMessage id="label.cancel" defaultMessage="Cancel" />
                )}
              </button>
              <button
                className={`${styles["primary"]}`}
                onClick={handleDiscard}
              >
                {okText || (
                  <FormattedMessage
                    id="unsaved.discardchanges"
                    defaultMessage="Discard changes"
                  />
                )}
              </button>
            </div>
          ) : (
            <div className={styles["no-action-footer"]} />
          )}
        </div>
      )}
    </div>
  );
};

export default UnsavedModal;
